import { Empty } from "antd";
import styled from "styled-components";

export const StyledAppError = styled(Empty)`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .ant-empty-image {
    height: auto;
  }
`;
